const styles = () => ({
  icon: {
    position: 'absolute',
    right: 10,
    top: 'calc(50% - 24px)',
  },
});

export default styles;
